import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=59b9b334&scoped=true&"
import script from "./NewNote.ts?vue&type=script&lang=ts&"
export * from "./NewNote.ts?vue&type=script&lang=ts&"
import style0 from "./NewNote.vue?vue&type=style&index=0&id=59b9b334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9b334",
  null
  
)

export default component.exports
import {QEditor,QBtnDropdown,QList,QItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QEditor,QBtnDropdown,QList,QItem,QItemSection,QIcon})
